import { FC } from "react";
import { Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import {StocksIcon} from "src/assets/Icons";
import { ExchangeInfoType } from "src/Modules/PointsExchange/constants";
import { formatNumber } from "src/utility";

type ConversionCardType = {
  exchangeInfo: ExchangeInfoType;
  isLoading?: boolean;
};

const ConversionCard: FC<ConversionCardType> = ({ exchangeInfo, isLoading }) => {
  const { t } = useTranslation();
  const points = exchangeInfo.conversionRate * (1 - exchangeInfo.fees / 100);
  const pointsRender = `${formatNumber(1)} ${exchangeInfo?.sourceUnitLabel ?? t("PointsExchange.exchange.point")} = ${formatNumber(points)} ${exchangeInfo?.destinationUnitLabel ?? t("PointsExchange.exchange.point")}`;
  return (
    <div className="flex items-center  justify-center md:justify-between w-full p-4 px-2 md:px-5 bg-background-minimal rounded-sm">
      <div className="text-xs font-medium uppercase text-font-subtle hidden md:block">{t("PointsExchange.exchange.exchangeRate")}</div>
      <div className="flex items-center justify-stretch gap-1">
        <StocksIcon className="text-icon-active h-5 w-5" />
        <Skeleton loading={isLoading} title={false} paragraph={{ rows: 1, width: "10rem" }} active>
          <div className="text-font-subtle text-sm font-bold">{pointsRender}</div>
        </Skeleton>
      </div>
    </div>
  );
};

export default ConversionCard;
